import { render, staticRenderFns } from "./dashboard-owing-summary.vue?vue&type=template&id=f76861fa&scoped=true&"
import script from "./dashboard-owing-summary.vue?vue&type=script&lang=js&"
export * from "./dashboard-owing-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76861fa",
  null
  
)

export default component.exports